import { Outlet, createFileRoute } from "@tanstack/react-router";

import { m } from "@/paraglide/messages.js";

/** Names the shelf between the library and one template: Library > Treningi > Template. */
export const Route = createFileRoute("/(private)/library/workouts")({
  loader: () => ({ crumb: m.library_tab_workouts() }),
  component: Outlet,
});
